import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchUsers,
  selectLoading,
  selectUsers
} from '../../features/users/usersSlice'

import { Button, Card, Form, Input, Space, Table, message } from 'antd'
import { Layout } from '../../components/Layout'
import { Spinner } from '../../components/Spinner'

import { api } from '../../api';
import { IS_ADMIN } from '../../constants';

const tailItemLayout = {
  wrapperCol: {
    xs: {
      span: 24
    },
    md: {
      offset: 6,
      span: 12
    }
  }
}

const COLUMNS = [
  {
    dataIndex: 'email',
    title: 'Email',
    width: 120
  },
  {
    dataIndex: 'first_name',
    title: 'First Name',
    width: 150
  },
  {
    dataIndex: 'last_name',
    title: 'Last Name',
    width: 150
  },
  {
    dataIndex: 'iam_username',
    title: 'IAM username',
    width: 150
  },
  {
    dataIndex: 's3_filepath',
    title: 'S3 FolderPath',
    width: 150
  }
]

export const ResetPassoword = () => {
    const dispatch = useDispatch();

    const [ passwordForm ] = Form.useForm();
    const [ passwordUpdating, setPasswordUpdating ] = useState(false);
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const token = params.get('token')

    const profileLoading = useSelector(selectLoading);
  
    if (profileLoading) return (
      <Spinner />
    );

    const onUpdatePassword = async ({ new_password, confirm_password }) => {
      try {
        setPasswordUpdating(true);
        await api('/api/reset_password', {  
            token,
            new_password, 
            confirm_password,
        });
        message.success("Password updated");
        passwordForm.resetFields();
      } catch (e) {
        message.error(e.message);
      } finally {
        setPasswordUpdating(false);
      }
    };
  
    

  return (
    <Layout.Content>
      <Space direction="vertical" size={50} style={{ display: 'flex' }}>
      <Card type="inner" title="Update Password">
        <Form
          size="large"
          layout="horizontal"
          onFinish={ onUpdatePassword }
          form={ passwordForm }
         >
          <Form.Item
          labelCol={{ span: 3 }} labelAlign={'left'}
            label="New Password"
            name="new_password"
            hasFeedback
            rules={[
              { required: true, message: 'Please enter a new password.' },
              { min: 8, message: 'Must be at least 8 characters long.' },
              {
                pattern: new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,64}$/),
                message: "Must be minimum of three of the following mix of character types: uppercase, lowercase, numbers, and ! @ # $ % ^ & * ( ) _ + - = [ ] { } | ' symbols"
              },
              { max: 64, message: 'Must be at most 64 characters long.' },
            ]}
          >
            <Input.Password autoComplete="new-password" disabled={ passwordUpdating } />
          </Form.Item>
          <Form.Item
            labelCol={{ span: 3 }} labelAlign={'left'}
            label="Confirm Password"
            name="confirm_password"
            dependencies={['new_password']}
            hasFeedback
            rules={[
              { required: true, message: 'Please enter a new password.' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" disabled={ passwordUpdating } />
          </Form.Item>
          <Form.Item {...tailItemLayout} style={{ textAlign: 'center'}}>
            <Button type="primary" htmlType="submit" loading={ passwordUpdating }>Update</Button>
          </Form.Item>
        </Form>
      </Card>
      </Space>  
    </Layout.Content>
  )
}
